<template>
	<app-modal modal-alignment="top" modal-id="deal-modal" modal-size="large" @close-modal="closeModal">
		<template slot="header">
			<h4 class="modal-title">{{ MoreTitle }}</h4>
			<button aria-label="Close" class="close outline-none" data-dismiss="modal" type="button">
				<span>
					<app-icon :name="'x'"></app-icon>
				</span>
			</button>
		</template>
		<template slot="body">
			<form v-if="dataLoaded" ref="form" :data-url="selectedUrl ? selectedUrl : `crm/deals`">
				<div class="form-group">
					<div class="form-row">
						<div class="col-12" v-if="formDataSave">
							<div class="row mb-3" v-for="(form, index) in formDataSave" :key="index">
								<div class="col-12">
									<div class="btn btn-primary d-flex align-items-center justify-content-between">
										<div>
											{{ findStageName(form.stage_id) }}
										</div>
										<div>
											{{ $t("Qty") }} {{ form.qty }}
										</div>
										<div>
											{{ $t("Summ") }} {{ numberWithCurrencyMuseum(form.summ_res) }}
										</div>
										<span @click.prevent="deleteForm(index)">
											<app-icon :name="'x'"></app-icon>
										</span>
									</div>

								</div>
							</div>
						</div>
						<template v-if="preloadFormDeal">
							<div class="col-3">
								<label class="mb-0 d-flex align-items-center font-weight-bold"
									style="height: 43px;">{{ $t("choose_type") }}</label>
								<app-input type="radio-stage" list-value-field="name" :list="stageListAsPipelineId"
									v-model="formData.stage_id" :error-message="$errorMessage(errors, 'stage_id')" />

								<p v-if="errors.stage_id" class="text-danger" style="font-size: 12px">
									{{ $t("this_field_is_required") }}
								</p>
							</div>
							<div class="col-9">
								<div class="form-group">
									<div class="form-row">
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">
											{{ $t("Qty") }}
										</label>
										<div class="col-sm-3">
											<app-input v-model="formData.qty" :list="QtyList" :required="true"
												type="select" />
										</div>
										<div class="col-sm-1"></div>
										<template v-if="pipelineType == 1">
											<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
												$t("vis") }}</label>
											<div class="col-sm-4">
												<app-input v-model="formData.vis" :list="VisList" :required="true"
													type="select" />
											</div>
										</template>
									</div>
								</div>
								<div class="form-group" v-if="!payType">
									<div class="form-row">
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
											$t("pay_id") }}</label>
										<div class="col-sm-10">
											<app-input type="radio-pay" list-value-field="name" :list="translatedPayList"
												v-model="formData.pay_id"
												:error-message="$errorMessage(errors, 'pay_id')" />
										</div>
									</div>
								</div>

								<div class="form-group" v-if="pipelineType == 1 && firstGanttId">
									<div class="form-row">
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
											$t("deal_gantt_title") }}</label>
										<div class="col-sm-10">
											<app-input type="single-checkbox" :list-value-field="ganttList.name"
												v-model="formData.gantt_id"
												:error-message="$errorMessage(errors, 'gantt_id')" />
										</div>
									</div>
								</div>
								<div class="citrum-sep"></div>
								<div class="form-group" v-if="pipelineType == 1">
									<div class="form-row">
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
											$t("sex")
										}}</label>
										<div class="col-sm-3">
											<app-input type="select" list-value-field="name" :list="translatedSexList"
												:placeholder="$t('choose_gender')" v-model="formData.sex_id"
												:error-message="$errorMessage(errors, 'sex_id')" />
										</div>
										<div class="col-sm-1"></div>
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
											$t("gid") }}</label>
										<div class="col-sm-4">
											<app-input v-model="formData.gid" :list="GidList" :required="true"
												type="select" />
										</div>
									</div>
								</div>
								<div class="form-group" v-if="pipelineType == 1">
									<div class="form-row">
										<label class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{
											$t("age")
										}}</label>
										<div class="col-sm-3">
											<app-input type="select" list-value-field="name" :list="translatedAgeList"
												:placeholder="$t('choose_age')" v-model="formData.age_id"
												:error-message="$errorMessage(errors, 'age_id')" />
										</div>
										<div class="col-sm-1"></div>
										<label
											class="mb-0 col-sm-2 d-flex align-items-center font-weight-bold">{{ $t("choose_channel") }}</label>
										<div class="col-sm-4">
											<app-input type="select" list-value-field="name" :list="translatedTrafList"
												:placeholder="$t('choose_traf')" v-model="formData.traf_id"
												:error-message="$errorMessage(errors, 'traf_id')" />
										</div>
									</div>
								</div>
								<template v-if="pipelineType != 3">
									<template v-if="pipelineType != 1">

										<div class="form-group">
											<div class="form-row">
												<label class="mb-0 col-sm-3 d-flex align-items-center font-weight-bold">
													<template v-if="pipelineType == 2">{{ $t("personex")
													}}</template>
													<template v-else>{{ $t("person") }}</template>
												</label>
												<div class="col-sm-9">
													<app-input v-model="formData.contextable_id" :list="personList"
														:placeholder="$t('choose_a_contact_person')"
														:error-message="$errorMessage(errors, 'contextable_id')"
														list-value-field="name" type="search-select" />
												</div>
											</div>
										</div>
										<div class="form-group">
											<div class="form-row" v-if="isCustomPriceStage">
												<label class="mb-0 col-sm-3 d-flex align-items-center font-weight-bold">
													{{ $t("deal_value") }}
												</label>
												<div class="col-sm-9">
													<app-input v-model="formData.value"
														:placeholder="'Введите сумму за группу'" type="number" />
												</div>
											</div>
										</div>

									</template>
								</template>
							</div>
						</template>
						<app-overlay-loader v-else />
						<div class="col-12 mt-2" v-if="pipelineType == 1 && formData.stage_id && formData.pay_id">
							<a href="#" @click.prevent="addMoreDeal">{{ $t('add_more_deal') }}</a>
						</div>
					</div>
				</div>
			</form>
			<app-overlay-loader v-else />
		</template>
		<template slot="footer">
			<div class="col-6" v-if="formData.stage_id && !totalSummRes">
				<div class="summ">{{ numberWithCurrencyMuseum(Summ) }}</div>
			</div>
			<div class="col-6" v-if="totalSummRes">
				<div class="summ">{{ numberWithCurrencyMuseum(nuSumm + totalSummRes) }} <span> ({{ totalPayType
				}})</span></div>
			</div>
			<div class="col-6 text-right">
				<button class="btn btn-secondary mr-2" data-dismiss="modal" type="button" @click.prevent="closeModal">
					{{ $t("cancel") }}
				</button>
				<span v-if="formData.pay_id">
					<span v-if="formData.stage_id">
						<button class="btn btn-primary" type="button" @click.prevent="submit">
							<span class="w-100">
								<app-submit-button-loader v-if="loading"></app-submit-button-loader>
							</span>
							<template v-if="!loading">{{ $t("sell") }}</template>
						</button>
					</span>
				</span>

			</div>

		</template>
	</app-modal>
</template>
<script>

import { FormMixin } from "@core/mixins/form/FormMixin";
import { api } from "@app/Helpers/api";
import { collect } from "@app/Helpers/Collection";
import { mapGetters } from "vuex";
import { getAllCustomFields } from "@app/Mixins/Global/CustomFieldMixin";
import { formatDateToLocal, formatDateTimeToLocal, numberWithCurrencySymbol, numberWithCurrencyMuseum, urlGenerator } from "@app/Helpers/helpers";

export default {

	name: "DealModal",
	mixins: [FormMixin, getAllCustomFields],
	props: {
		preSelectedOption: Object,
		selectedUrl: String,
		MoreTitle: String,
		tableId: String,
		pipelineId: Number,
		pipelineType: String,
		pipelineName: String,
		selectedStageIndex: Number,
	},
	data() {
		return {
			numberWithCurrencySymbol,
			numberWithCurrencyMuseum,
			formData: {
				gantt_id: null,
				owner_id: user.id,
				qty: "1",
				stage_id: null,
				sex_id: "2",
				age_id: "4",
				gid: "1",
				traf_id: "1",
				vis: "1",

				expo_id: "1",
				pipeline_id: this.pipelineId,
				lead_type: 1,
				contextable_id: "",
			},
			payType: '',
			preloadFormDeal: true,
			formDataSave: [],
			ganttOn: false,
			addEditData: {},
			addEditDataNew: {},
			contactTypeList: [],
			QtyList: [
				{ id: "1", value: "1", },
				{ id: "2", value: "2", },
				{ id: "3", value: "3", },
				{ id: "4", value: "4", },
				{ id: "5", value: "5", },
				{ id: "6", value: "6", },
				{ id: "7", value: "7", },
				{ id: "8", value: "8", },
				{ id: "9", value: "9", },
				{ id: "10", value: "10", },
				{ id: "11", value: "11", },
				{ id: "12", value: "12", },
				{ id: "13", value: "13", },
				{ id: "14", value: "14", },
				{ id: "15", value: "15", },
				{ id: "16", value: "16", },
				{ id: "17", value: "17", },
				{ id: "18", value: "18", },
				{ id: "19", value: "19", },
				{ id: "20", value: "20", },
				{ id: "21", value: "21", },
				{ id: "22", value: "22", },
				{ id: "23", value: "23", },
				{ id: "24", value: "24", },
				{ id: "25", value: "25", },
				{ id: "26", value: "26", },
				{ id: "27", value: "27", },
				{ id: "28", value: "28", },
				{ id: "29", value: "29", },
				{ id: "30", value: "30", },

			],

			VisList: [
				{ id: "1", value: this.$t("Первый раз"), },
				{ id: "2", value: this.$t("Постоянный"), },
				{ id: "3", value: this.$t("Неопределено"), },
			],
			GidList: [
				{ id: "2", value: this.$t("Русский"), },
				{ id: "1", value: this.$t("Без аудиогида"), },
				{ id: "3", value: this.$t("Украинский"), },
				{ id: "4", value: this.$t("Английский"), },
				{ id: "5", value: this.$t("Китайский"), },
				{ id: "6", value: this.$t("Неопределено"), },
			],

			expoList: [
				{ id: "1", value: "Нет", },
				{ id: "2", value: "им. Леси Украинки", },
			],


			pipelineList: [],


			stageList: [],
			stageId: {},
			errors: [],
			dataLoaded: false,
			loading: false,
			pipelineChange: true,
			customFieldValue: [],
		};
	},
	computed: {

		translatedPayList() {

        return this.payList.map(item => ({

            ...item,

            name: this.$t(item.name)

        }));

    },

	translatedAgeList() {

		return this.ageList.map(item => ({

			...item,

			name: this.$t(item.name)

		}));

	},
	translatedSexList() {
		return this.sexList.map(item => ({

			...item,

			name: this.$t(item.name)

		}));

	},

	translatedTrafList() {
		return this.trafList.map(item => ({

			...item,

			name: this.$t(item.name)

		}));
	},
	




		selectedStage() {

			return this.stageList.find(stage => stage.id == this.formData.stage_id);

		},

		isCustomPriceStage() {

			return this.selectedStage && Number(this.selectedStage.custom_price) === 1;

		},
		totalPayType() {
			let filtered = this.payList
				.filter(v => v.id == this.formData.pay_id)
				.map(v => v.name);

			return filtered.length > 0 ? filtered[0] : '';
		},
		totalSummRes() {
			return this.formDataSave.reduce((total, item) => {
				return total + Number(item.summ_res);
			}, 0);
		},
		firstGanttId() {
			return this.ganttList ? this.ganttList.id : null;
		},

		personListAsOrg() {
			return this.personList.filter((item) =>
				item.organizations.find(el =>
					el.id == this.formData.contextable_id
				)
			);
		},
		stageListAsPipelineId() {
			this.loadStepInput();
			return this.stageList.filter(
				(v) => v.pipeline_id == this.formData.pipeline_id
			);
		},


		filteredLastItem() {
			var koho = this.formData.stage_id;
			if (this.formData.stage_id) {
				var goho = this.stageList.filter(function (elem) {
					if (elem.id == koho) return elem.name;
				});
				return goho[0].probability;
			} else {
				return 0;
			}

		},

		filteredLastItemName() {
			var koho = this.formData.stage_id;
			if (this.formData.stage_id) {
				var goho = this.stageList.filter(function (elem) {
					if (elem.id == koho) return elem.name;
				});
				return goho[0].name;
			} else {
				return 'Noname';
			}

		},
		Summ() {
			if (this.isCustomPriceStage) {
				return this.formData.value || 0;
			}

			return this.filteredLastItem * this.formData.qty;

		},



		ChAge() {



		},



		filteredPipl() {
			var poho = this.formData.pipeline_id;
			var noho = this.pipelineList.filter(function (elem) {
				if (elem.id == poho) return elem.name;
			});
			return noho[0].name;
		},





		stageIndexAsId() {
			let index = undefined;
			let stageListByPipeLine = this.stageList.filter(
				(v) => v.pipeline_id == this.formData.pipeline_id
			);
			for (let i = 0; i < stageListByPipeLine.length; i++) {
				if (stageListByPipeLine[i].id === this.formData.stage_id) {
					index = i;
				}
			}
			return index;
		},

		...mapGetters({
			payList: "getPay",
			ageList: "getAge",
			sexList: "getSex",
			trafList: "getTraf",
			ownerList: "getOwner",
			organizationList: "getOrganization",
			personList: "getPersongid",
			dealList: "getDeal",
			ganttList: "getGantt",
		}),
	},
	created() {

		this.$store.dispatch('getSex');
		this.$store.dispatch('getAge');
		this.$store.dispatch('getTraf');
		this.$store.dispatch('getPay');
		this.$store.dispatch('getGantt');
		this.getData();



		//preSelectedOption are set in here
		if (this.preSelectedOption) {
			if (this.preSelectedOption.organization_id) {
				this.formData.organization_id = this.preSelectedOption.organization_id;
			}
			if (this.preSelectedOption.person_id) {
				this.formData.person_id = this.preSelectedOption.person_id;
			}
			if (this.preSelectedOption.fund_id) {
				this.formData.fund_id = this.preSelectedOption.fund_id;
			}
		}
		//end of preSelectedOption set
		// this.getPipeline();
		this.getStages();
		this.getAllCustomFields("deal");
		this.$nextTick(() => {
			if (this.$props.selectedStageIndex != undefined) {
				this.formData.stage_id = this.$props.selectedStageIndex;
			}
		});
	},
	methods: {
		findStageName(id) {
			let filtered = this.stageList
				.filter(v => v.id == id)
				.map(v => v.name);

			return filtered.length > 0 ? filtered[0] : '';
		},

		deleteForm(index) {
			this.formDataSave.splice(index, 1);
		},

		addMoreDeal() {

			this.preloadFormDeal = false;
			this.formData.summ_res = this.Summ;
			this.formData.value = this.Summ;
			this.formData.contextable_id = 100002;
			this.formData.title = this.pipelineName + ' - ' + this.filteredLastItemName;
			this.payType = this.formData.pay_id;
			let formDataCopy = JSON.parse(JSON.stringify(this.formData));

			this.formDataSave.push(formDataCopy);

			this.formData.summ_res = '';
			this.formData.stage_id = '';
			this.formData.title = '';
			this.formData.qty = 1;
			//this.formData.pay_id = '';
			setTimeout(() => {
				this.preloadFormDeal = true;
			})


		},
		getData() {

			this.axiosGet(`admin/app/settings`).then(response => {
				this.appSettings = response.data;


			}).catch(({ error }) => {
			});
		},



		loadStepInput() {
			this.pipelineChange = false;
			this.$nextTick(() => {
				this.pipelineChange = true;
			});
		},
		beforeSubmit() {
			this.loading = true;
		},
		submit() {
			// let customData = [];
			// this.customFields.map((el) => {
			// 	if (this.customFieldValue[el.name]) {
			// 		let item = {
			// 			value:
			// 				el.custom_field_type.name == "checkbox"
			// 					? el.meta.split(",").filter((e, i) => {
			// 						if (
			// 							this.customFieldValue[el.name].includes(String(i)) ||
			// 							this.customFieldValue[el.name].includes(i)
			// 						) {
			// 							return e;
			// 						}
			// 					})
			// 					: el.custom_field_type.name == "select" ||
			// 						el.custom_field_type.name == "radio"
			// 						? el.meta.split(",").find((e, i) => {
			// 							return i == Number(this.customFieldValue[el.name]);
			// 						})
			// 						: this.customFieldValue[el.name],
			// 			custom_field_id: el.id,
			// 		};

			// 		customData.push(item);
			// 	}
			// });

			//Marketing
			if (this.pipelineType == 1) {
				this.addEditData.traf_id = this.formData.traf_id;
				this.addEditData.vis = this.formData.vis;
				this.addEditData.gid = this.formData.gid;
				this.addEditData.sex_id = this.formData.sex_id;
				this.addEditData.age_id = this.formData.age_id;
			} else {
				this.addEditData.traf_id = 6;
				this.addEditData.vis = 3;
				this.addEditData.gid = 6;
				this.addEditData.sex_id = 3;
				this.addEditData.age_id = 7;

				this.addEditDataNew.traf_id = 6;
				this.addEditDataNew.vis = 3;
				this.addEditDataNew.gid = 6;
				this.addEditDataNew.sex_id = 3;
				this.addEditDataNew.age_id = 7;
			}


			this.addEditData.gantt_id = this.formData.gantt_id ? this.firstGanttId : null;

			this.addEditData.pay_id = this.formData.pay_id;
			this.addEditData.person_id = this.formData.person_id;
			this.addEditData.fund_id = this.formData.fund_id;
			this.addEditData.lead_type = this.formData.lead_type;
			// this.addEditData.customs = customData;
			this.addEditData.stage_id = this.formData.stage_id;
			this.addEditData.title = this.pipelineName + ' - ' + this.filteredLastItemName;
			this.addEditData.pipeline_id = this.formData.pipeline_id;
			this.addEditData.owner_id = this.formData.owner_id;


			this.addEditDataNew.pay_id = 1;
			this.addEditDataNew.person_id = this.formData.person_id;
			this.addEditDataNew.fund_id = this.formData.fund_id;
			this.addEditDataNew.lead_type = this.formData.lead_type;
			// this.addEditDataNew.customs = customData;
			this.addEditDataNew.stage_id = 61;
			this.addEditDataNew.title = 'Гид';
			this.addEditDataNew.pipeline_id = 13;
			this.addEditDataNew.owner_id = this.formData.owner_id;
			this.addEditDataNew.contextable_id = this.formData.contextable_id;
			this.addEditDataNew.value = 500;


			if (this.formData.contextable_id != 0) {
				if (this.formData.stage_id == 33) {
					this.addEditData.contextable_id = 100002;
				} else {
					this.addEditData.contextable_id = this.formData.contextable_id;
				}
			} else {
				this.addEditData.contextable_id = 100002;
			}



			if (this.pipelineType != 1 && this.pipelineType != 3 && this.pipelineType != 2) {
				this.addEditData.value = this.formData.value;
			} else {

				// todo this 
				if (this.isCustomPriceStage) {
					// if (this.formData.pay_id == 2) {
					// 	this.addEditData.value = this.formData.value / this.formData.qty - ((this.formData.value / this.formData.qty) * this.appSettings.card / 100);
					// } else if (this.formData.pay_id == 3) {
					// 	this.addEditData.value = this.formData.value / this.formData.qty - ((this.formData.value / this.formData.qty) * this.appSettings.liq / 100);
					// } else {
					// 	this.addEditData.value = this.formData.value / this.formData.qty;
					// }
					this.addEditData.value = this.formData.value / this.formData.qty;
				} else {
					// console.log('filteredLastItem: ', this.filteredLastItem);
					// console.log('appSettings: ', this.appSettings);
					// if (this.formData.pay_id == 2) {
					// 	this.addEditData.value = this.filteredLastItem - (this.filteredLastItem * this.appSettings.card / 100);
					// } else if (this.formData.pay_id == 3) {
					// 	this.addEditData.value = this.filteredLastItem - (this.filteredLastItem * this.appSettings.liq / 100);
					// } else {
					// 	this.addEditData.value = this.filteredLastItem;
					// }

					this.addEditData.value = this.filteredLastItem;
				}
			}














			this.addEditData.expired_at = this.formData.expired_at ? moment(this.formData.expired_at).format("YYYY-MM-DD") : null;
			this.addEditDataNew.expired_at = this.formData.expired_at ? moment(this.formData.expired_at).format("YYYY-MM-DD") : null;


			this.addEditData.status_id = 12;
			this.addEditDataNew.status_id = 12;
			if (this.formDataSave) {
				for (let item of this.formDataSave) {
					for (var i = 0; i < item.qty; i++) {
						this.save(item);
					}

				}
			}

			for (var i = 0; i < this.formData.qty; i++) {
				this.save(this.addEditData);

			}


			if (this.formData.stage_id == 33) {
				this.save(this.addEditDataNew);
			}

			console.log('form: ', this.formData);

		},
		afterError(response) {
			this.loading = false;
			this.errors = response.data.errors;
		},
		afterSuccess(response) {
			this.$store.dispatch("getDeal");
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.$emit("saved");
			this.$hub.$emit("deal-update-list");
			this.closeModal();
		},
		afterFinalResponse() {
			this.loading = false;
		},
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;
			this.formData.person_id = this.formData.contact_person[0].id;
			this.formData.fund_id = this.formData.contact_fund[0].id;
			let expired_at = response.data.expired_at.split(" ");
			this.formData.expired_at = new Date(expired_at);
			this.getAllCustomFields("deal");
		},
		closeModal(value) {
			this.$emit("close-modal", value);
		},
		// getPipeline() {
		// 	this.axiosGet("crm/pipelines")
		// 		.then((response) => {
		// 			this.pipelineList = this.collection(response.data.data).shaper(
		// 				"name"
		// 			);
		// 			if (!this.formData.pipeline_id) {
		// 				this.formData.pipeline_id = response.data.data[0].id;
		// 			}
		// 		})
		// 		.catch(({ error }) => {
		// 		});
		// },
		getStages() {
			this.axiosGet("crm/stages?all")
				.then((response) => {
					this.stageList = collect(response.data).where('pipeline_id', this.formData.pipeline_id).sortBy('priority').get();
					this.stageId = this.stageList.find(
						(v) => v.pipeline_id == this.formData.pipeline_id
					);

					this.dataLoaded = true;
				})
				.catch(({ error }) => {
				});
		},
		setStageId(index) {
			if (this.stageListAsPipelineId.length) {
				this.formData.stage_id = this.stageListAsPipelineId[index].id;
			}

		},
		changeLeadType() {
			this.formData.contextable_id = null;
		}
	},
	mounted() {
		this.formData.gantt_id = this.firstGanttId;
	},
};
</script>
